var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),_c('vue-snotify'),_c('a',{staticClass:"telegram-btn",attrs:{"href":`https://t.me/${_vm.$store.state.telegramUserName}`,"id":"telegram-btn","target":"_blank"}},[_c('img',{attrs:{"src":require("../public/img/svg/telegram.svg"),"alt":""}}),_c('span',[_vm._v("Задать вопрос в телеграм")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }